import { setSourceUpdateStatus } from '@shoflo/studio-redux/actions';
import { withCurrentParams } from 'actions/utils';
import { SOURCE_TOGGLE } from 'store/eventConstants';
import { BROADCAST_UPDATE_SOURCE } from 'actions/Types';
import { getSignedUrl } from 'utils/broadcastSourceHelper';
import { UPDATE_PENDING } from '@shoflo/studio-redux/constants/SourceUpdateStatuses';

export default (sourceId, changes, config = {}) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const action = {
        type: BROADCAST_UPDATE_SOURCE,
        request: async apiClient => {
          dispatch(setSourceUpdateStatus(sourceId, UPDATE_PENDING));

          const response = await apiClient.broadcast.updateSource(
            teamId,
            eventId,
            broadcastId,
            sourceId,
            changes
          );
          const updatedSource = await getSignedUrl(
            {
              ...response,
              team: teamId,
              event: eventId
            },
            apiClient
          );

          // Get state as late as possible so as to have the most recent version of liveSources and program.
          // This reduces or eliminates the possibility of a program update that overrides a newer version
          const {
            meeting: { attendeeResponse }
          } = getState();

          // notify other directors
          socket.emit(SOURCE_TOGGLE, {
            broadcastId,
            notifyingDirector: attendeeResponse?.Attendee?.AttendeeId,
            source: updatedSource
          });

          return updatedSource;
        },
        config
      };

      dispatch(action);
    }
  );
};
